const LAYOUT_CONST = {
    VERTICAL_LAYOUT: 'vertical',
    HORIZONTAL_LAYOUT: 'horizontal',
    DEFAULT_DRAWER: 'default',
    MINI_DRAWER: 'mini-drawer'
};

export default LAYOUT_CONST;

export const TABLE_CONST = {
    DEFAULT_PER_PAGE: 20,
    DEFAULT_EXPORT_DATA: [
        { col: 'learnerId', title: 'Candidate ID' },
        { col: 'name.first', title: 'First Name' },
        { col: 'name.last', title: 'Last Name' },
        { col: 'email', title: 'Email' },
        { col: 'completeTime', title: 'Complete Time' }
    ],
    DATE_RANGE: [
        { range: -1, type: 'month', title: 'Last Month' },
        { range: -3, type: 'month', title: 'Last 3 Months' },
        { range: -12, type: 'month', title: 'Last 12 Months' }
    ]
};

export const EMAIL_TEMPLATES = {
    firstEmail: () => ({
        templateKey: 'ACSF',
        label: 'First Email',
        subject: 'Access your LLN Robot Trial',
        body: `<p>Hello <variable>trialRequestFirstName</variable>,</p>
  <p>Welcome to your free 3 week trial of LLN Robot.</p>
  <p>You can log into your trial by following this link: </p>
  <p><a href="<variable>trialURL</variable>"><variable>trialURL</variable></a></p>
  <p>To activate your account, please click this <a href="<variable>passwordResetURL</variable>" target="_blank">link</a>. You will be prompted to set your own password.</p>
  <p>Please find an overview of how to use the LLN Robot System attached to this email.</p>
  <p>Once logged in you will notice there are some options within the system that have been disabled. These are not available in the trial version of the system.</p>
  <p>This trial contains access to the <b>Course Ready - Digital Readiness for Learning Questionnaire</b> which is a feature you can add as an optional cost. Please see the website for pricing information. More information on this can be found <a href="https://tlrg.com.au/pages/lln-digital-capability">here</a>.</p>
  <p>To speak with one of our sales team about implementing the LLN Robot System in your training organisation please email <a href="mailto:sales@tlrg.com.au">sales@tlrg.com.au</a> or call 1300 221 729.</p>
  <p>Kind regards.</p>
  <p>Matt Peachey<br/>Managing Director<br/>The Learning Resources Group</p>`
    }),
    secondEmail: ({ forBusiness = false } = {}) => {
        const forBusinessClause = forBusiness
            ? `<p>If you would like to book a consultation with the team to discuss how it might work for you organisation you can click <a href="https://tlrg.com.au/pages/book-a-consultation">here</a>.</p>`
            : '';
        return {
            templateKey: 'VSL',
            label: 'Second Email',
            subject: `You’re one week into your LLN Robot Trial`,
            body: `<p>Hello <variable>trialRequestFirstName</variable>,</p>
<p>Just thought I’d let you know that you’re one week into your trial of the LLN Robot. Don’t worry, you still have another 2 weeks to trial the system.</p>
<p>You can log into your trial by following this link: <a href="<variable>trialURL</variable>"><variable>trialURL</variable></a></p>
<p>If you’re enjoying your trial you can get a quote and more information here: <a href="https://tlrg.com.au/pages/lln-digital-capability">https://tlrg.com.au/pages/lln-digital-capability</a></p>
<p>To speak with one of our sales team about implementing the LLN Robot in your organisation please email <a href="mailto:sales@tlrg.com.au">sales@tlrg.com.au</a> or call 1300 221 729.</p>
${forBusinessClause}
<p>Kind regards.</p>
<p>Matt Peachey<br/>Managing Director<br/>The Learning Resources Group</p>`
        };
    },
    thirdEmail: () => ({
        templateKey: 'ET',
        label: 'Third Email',
        subject: 'One week to go on your LLN Robot System Trial',
        body: `<p>Hello <variable>trialRequestFirstName</variable>,</p>
<p>You only have one more week available on your LLN Robot System Trial.</p>
<p>Please note, the data stored in the trial will be deleted after the trial expires so please ensure you download any learner results you would like to retain.</p>
<p>You can log into your trial by following this link: <a href="<variable>trialURL</variable>"><variable>trialURL</variable></a></p>
<p>See the different LLN Robot System packages and find the perfect size for you. Get a Quote Today: <a href="https://tlrg.com.au/pages/lln-digital-capability">https://tlrg.com.au/pages/lln-digital-capability</a></p>
<p>To speak with one of our sales team about implementing the LLN Robot System in your training organisation please email <a href="mailto:sales@tlrg.com.au">sales@tlrg.com.au</a> or call 1300 221 729.</p>
<p>Kind regards.</p>
<p>Matt Peachey<br/>Managing Director<br/>The Learning Resources Group</p>`
    }),
    fourthEmail: () => ({
        templateKey: 'FT',
        label: 'Fourth Email',
        subject: 'Your LLN Robot System Trial has Expired',
        body: `<p>Hello <variable>trialRequestFirstName</variable>,</p>
<p>Your free 3 week trial of LLN Robot System has now expired.</p>
<p>If you would like more information or a quote for implementing the LLN Robot System into your organisation please go to: <a href="https://tlrg.com.au/pages/lln-digital-capability">https://tlrg.com.au/pages/lln-digital-capability</a></p>
<p>To speak with one of our sales team about implementing the LLN Robot System in your training organisation please email <a href="mailto:sales@tlrg.com.au">sales@tlrg.com.au</a> or call 1300 221 729.</p>
<p>Kind regards.</p>
<p>Matt Peachey<br/>Managing Director<br/>The Learning Resources Group</p>`
    })
};

export const EMAIL_TEMPLATE_VARIABLES = [
    {
        id: 'trialRequestFirstName',
        label: 'RequestorFirstName',
        canAddTo: {
            subject: true,
            body: true
        },
        templates: ['All']
    },
    {
        id: 'trialURL',
        label: 'TrialURL',
        canAddTo: {
            subject: false,
            body: true
        },
        templates: ['All']
    }
];
